import { mutator } from 'satcheljs';
import { assertNever } from 'owa-assert';
import { DateRangeFilter } from 'owa-files-filter-date-filter';
import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';
import { FilterType } from '../Schema/FilterState';
import { getFilterStore } from '../store/FilterStore';
import { updateItemsViewCache } from '../store/cache';
import { selectDateFilterAction, selectExtensionFilterAction } from 'owa-files-filter-contextmenu';
import { selectColumnSortAction } from '../actions/internalActions';
import { logUsage } from 'owa-analytics';
import { getParameterStore } from '../store/ParametersStore';

// exported for typings
export function selectFilter(
    type: FilterType.BroadExtensionGroupFilter,
    value: FileExtensionType.Files | FileExtensionType.Images
);
export function selectFilter(type: FilterType.ExtensionGroup, value: FileExtensionType);
export function selectFilter(type: FilterType.DateRange, value: DateRangeFilter);
export function selectFilter(type: FilterType.Folder, value: string);
export function selectFilter(type: FilterType.PhotosOnly);
export function selectFilter(type: FilterType.Size, value: number);
export function selectFilter(type: FilterType.Search, value: string);
export function selectFilter(type: FilterType.ColumnSort, value: number[]);
export function selectFilter(
    type: FilterType,
    value?: FileExtensionType | DateRangeFilter | string | number | number[]
) {
    const filterState = getFilterStore();

    logUsage('FilesViewSelectFilter', { scenario: getParameterStore().scenarioName });

    if (value === null || (value === undefined && type !== FilterType.PhotosOnly)) {
        throw new Error(`Cannot select Attachment Filter value ${value} for type ${type}`);
    }

    switch (type) {
        case FilterType.BroadExtensionGroupFilter:
            filterState.broadExtensionGroupFilter.selectedValue = value as
                | FileExtensionType.Files
                | FileExtensionType.Images;
            break;
        case FilterType.ExtensionGroup:
            filterState.extensionGroupFilter.selectedValue.set(value.toString(), '');
            break;
        case FilterType.DateRange:
            filterState.dateRangeFilter.selectedValue = value as DateRangeFilter;
            break;
        case FilterType.Folder:
            filterState.folderFilter.selectedValue = value as string;
            break;
        case FilterType.Size:
            filterState.sizeFilter.selectedValue = value as number;
            break;
        case FilterType.PhotosOnly:
            filterState.photosOnlyFilter.selectedValue = true;
            break;
        case FilterType.Search:
            filterState.searchFilter.selectedValue = value as string;
            break;
        case FilterType.ColumnSort:
            filterState.columnSort.selectedValue = value as number[];
            break;
        default:
            assertNever(type);
    }

    updateItemsViewCache();
}

mutator(selectDateFilterAction, actionMessage => {
    selectFilter(FilterType.DateRange, actionMessage.value);
});

mutator(selectExtensionFilterAction, actionMessage => {
    selectFilter(FilterType.ExtensionGroup, actionMessage.value);
});

mutator(selectColumnSortAction, actionMessage => {
    selectFilter(FilterType.ColumnSort, actionMessage.value);
});
